// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyAugMYdm8YBikf8UK3vgFR3IogsSTS7IcI",
  authDomain: "digiact-ceb5f.firebaseapp.com",
  projectId: "digiact-ceb5f",
  storageBucket: "digiact-ceb5f.appspot.com",
  messagingSenderId: "692833777825",
  appId: "1:692833777825:web:458696191cff9fa13118e0"
};

// Initialize Firebase
